import styled from 'styled-components';

export const ButtonCell = styled.td`
  width: ${props => props.width};
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  border: thin solid ${({ theme }) => theme && theme.borderColor};
  cursor: pointer;

  @media only screen and (max-width: 580px) {
    display: none;
  }
`;
